import { Directive, HostListener } from '@angular/core';

const whiteListSingle = ['Backspace', 'Delete', 'Tab', `Escape`];

/* Just to clarify what Backquote is doing here:
 *  We had an issue when users with Hungarian keyboard could not type in zero number: https://epicuro.atlassian.net/browse/RTP-1462
 *  It's done with key combination of Option + Backquote
 *  Because of that, it was needed to add Backquote to whitelist
 * */
const whiteListWithModifier = ['KeyC', 'KeyV', 'KeyX', 'KeyA', 'Backquote'];

@Directive({
  selector: '[atxNumberInput]',
  standalone: false,
})
export class NumberInputDirective {
  @HostListener('keydown', ['$event'])
  public onKeyDown(event: KeyboardEvent) {
    const code = event.code;
    const key = event.key;

    return (
      !isNaN(+key) ||
      whiteListSingle.includes(code) ||
      whiteListSingle.includes(key) ||
      (whiteListWithModifier.includes(code) &&
        (event.ctrlKey || event.metaKey || event.altKey))
    );
  }
}
